import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Food & Inventory',
  icon: 'mdi-clipboard-outline',
  path: '/reports/controls/',
  ...addPermissionsToRoute(['mtFood']),
  children: [
    {
      path: '/reports/controls/foodDashboard',
      meta: { id: 'reports-mtControlsFoodDashboard' },
      name: 'Food At A Glance',
      component: () => import('./dashboard/FoodDashboard.vue'),
    },
    {
      path: '/reports/controls/inventoryVariance',
      meta: { id: 'reports-mtControlsInventoryVariance' },
      name: 'Inventory Variance',
      component: () => import('./InventoryVariance.vue'),
    },
    {
      path: '/reports/controls/usageFoodCost',
      meta: { id: 'reports-mtControlsUsageFoodCost' },
      name: 'Food Cost',
      component: () => import('./UsageFoodCost.vue'),
    },
    {
      path: '/reports/controls/foodOverBase',
      meta: { id: 'reports-fob' },
      name: 'Food Over Base',
      component: () => import('./FoodOverBase.vue'),
    },
    {
      path: '/reports/controls/rawWastePromo',
      meta: { id: 'reports-rawWastePromo' },
      name: 'Raw Waste & Promo',
      component: () => import('./rawWaste/RawWastePromoWrapper.vue'),
    },
    {
      path: '/reports/controls/wastePromoDetail',
      meta: { id: 'reports-compWasteDetail' },
      name: 'Completed Waste',
      component: () => import('./compWaste/CompWasteWrapper.vue'),
      tags: ['Completed Waste Detail'],
    },
    {
      path: '/reports/controls/inventory',
      meta: { id: 'reports-physicalInventory' },
      name: 'Inventory',
      component: () => import('./inventory/InventoryWrapper.vue'),
      tags: ['Ending Inventory Cost'],
    },
    {
      path: '/reports/controls/transfers',
      meta: { id: 'reports-transfers' },
      name: 'Transfers & Purchases',
      component: () => import('./transfers/TransfersReport.vue'),
    },
    {
      path: '/reports/controls/wasteVariance',
      meta: { id: 'reports-mtControlsWasteVariance' },
      name: 'Waste Variance',
      component: () => import('./WasteVariance.vue'),
    },
  ],
};

export default routes;
